import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { isBefore, isAfter, differenceInHours, format } from 'date-fns';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { dominioDemandaCirurgica, dominioOperaAspNet } from '../../config/database';
import { PendenciasWizard, setPendencia } from './ValidacaoWizard';
import 'assets/css/data-cirurgia.css';

class DataCirurgia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderizar: false,
      semanasCarregadas: [],
      eventosAgendamento: [],
      eventos: [],
      programacoes: [],
      duracaoTotal: 0,
      eventoAgendamentoClickado: false,
      bloqueiaInternacao: null,
      internacao: null,
      bloqueioRecursoSistemaInternacaoPedidoCirurgia: false,
      dataInternacao: new Date(null),
      dataSugerida: null,
      motivoAntecipacaoInternacao: null,
      listaMotivosAntecipacaoInternacao: [],
      listaTipoAcomodacao: [],
      tipoAcomodacao: null,
      leitoUTI: false,
      perspectivaValidacaoDasHorasUteis: null,
      perspectivaValidacaoDasHorasCorridas: null,
      perspectivaValidacaoDosDiasUteis: null,
      perspectivaValidacaoDosDiasCorridos: null,
      slaCaraterUrgencia: null,
      slacaraterEletivo: null,
      caraterUrgencia: null,
      caraterEletivo: null,
      perspectivaValidacaoDosDias: null,
      carater: {},
      impedirEventoAgendamento: null,
      equipeMedica: null,
      centroCirurgico: null,
      salasCirurgicas: [],
      salaCirurgicaSelecionada: 0,
      listaSalas: [],
      modalidadeAtendimento: null,
      modalidadeAmbulatorial: null,
    };

    this.calendarRef = React.createRef();
  }

  componentDidMount() {
    this.alimentarStates();

    setTimeout(() => {
      if (!(JSON.parse(localStorage.getItem('equipeRequisitante')).idLegado === 9973  &&
      JSON.parse(localStorage.getItem('centroCirurgico')).idLegado === 556)) {
        this.carregaProgramacoes();

        if (this.state.salaCirurgicaSelecionada > 0 && !localStorage.getItem('dataSugerida') && (this.state.carater.id === this.state.caraterEletivo)) {
          this.setState({ salaCirurgicaSelecionada: 0 });

          if (localStorage.getItem('salaCirurgia')) localStorage.removeItem('salaCirurgia');
        }

        // remove a sala cirurgica do localStorage quando for carater eletivo
        if ((this.state.carater.id === this.state.caraterEletivo) && localStorage.getItem('salaCirurgia') && !localStorage.getItem('dataSugerida')) 
          localStorage.removeItem('salaCirurgia');

        this.setState({ renderizar: true });

        // tratamento quando data sugerida esta no localStorage
        if (localStorage.getItem('dataSugerida')) {
          if (this.calendarRef.current)
            this.calendarRef.current.getApi().gotoDate(Date.parse(moment(localStorage.getItem('dataSugerida'))));

          this.dataSugeridaPreenchida(localStorage.getItem('dataSugerida'));
        }
      } else if (localStorage.getItem('dataSugerida')) {
        this.dataSugeridaPreenchida(localStorage.getItem('dataSugerida'));
      }

      const elementoTimeGridWeek = document.querySelector('.data-cirurgia-pedido .fc-timeGridWeek-view');

      if (elementoTimeGridWeek && this.state.salaCirurgicaSelecionada === 0 && !this.state.dataSugerida)
        elementoTimeGridWeek.classList.add('sem-sala');

      if (!this.state.renderizar) this.setState({ renderizar: true });
    }, 350);
  }

  componentDidUpdate(prevProps, prevState) {
    // nao permitir o agendamento quando houver algum retorno negativo do handleValidarDataSugerida
    if (prevState.impedirEventoAgendamento !== this.state.impedirEventoAgendamento && this.state.impedirEventoAgendamento !== null) {
      if (!this.calendarRef.current) return;
      
      localStorage.removeItem('dataSugerida');

      if (this.calendarRef.current.getApi().getEventById('agendado'))
        this.calendarRef.current.getApi().getEventById('agendado').remove();

      if (this.state.carater.id === this.state.caraterEletivo)  localStorage.removeItem('salaCirurgia');
      
      this.showWarn('Data não pode ser utilizada, selecione outra.', 'warn');

      this.setState({
        eventos: this.state.eventos.concat(this.state.eventosAgendamento),
        impedirEventoAgendamento: null,
        eventoAgendamentoClickado: false
      });
    }

    if (document.querySelector('.data-cirurgia-pedido .fc-header-toolbar .fc-toolbar-chunk:first-child')) {
      let selecaoSalas = (
        <Autocomplete
          id="selecaoSalas"
          style={{ width: '220px' }}
          options={this.state.listaSalas}
          getOptionLabel={option => `${option.nomeSala ?? ''}`}
          onChange={(e, value) => {
            this.selecionaSalaCirurgica(value);
          }}
          value={this.state.listaSalas.filter((item) => item.salaCirurgia_id == this.state.salaCirurgicaSelecionada)[0] ?? ''}
          filterSelectedOptions
          renderInput={params => (
            <TextField {...params} label="Selecione a sala" variant="outlined" />
          )}
        />
      );

      if (document.querySelector('.data-cirurgia-pedido .lista-salas')) {
        ReactDOM.render(selecaoSalas, document.querySelector('.data-cirurgia-pedido .lista-salas'));
      } else {
        let novaDiv = document.createElement('div');
        novaDiv.classList.add('lista-salas');
        document.querySelector('.data-cirurgia-pedido .fc-header-toolbar .fc-toolbar-chunk:first-child').appendChild(novaDiv);
        ReactDOM.render(selecaoSalas, novaDiv);
      }
    }

    if (prevState.salaCirurgicaSelecionada !== this.state.salaCirurgicaSelecionada) {
      const elementoTimeGridWeek = document.querySelector('.data-cirurgia-pedido .fc-timeGridWeek-view');

      if (elementoTimeGridWeek) {
        if (this.state.salaCirurgicaSelecionada === 0)
          elementoTimeGridWeek.classList.add('sem-sala');
        else
          elementoTimeGridWeek.classList.remove('sem-sala');
      }
    }
  }

  selecionaSalaCirurgica(value) {
    this.setState({
      salaCirurgicaSelecionada: value ? value.salaCirurgia_id : 0,
    });

    if (this.state.eventoAgendamentoClickado) this.removerAgendamento();

    if (this.calendarRef.current)
      this.calendarRef.current.getApi().gotoDate(Date.now());

    this.setState({
      eventos: [],
      eventosAgendamento: [],
      semanasCarregadas: [],
    });
  }

  async carregaProgramacoes() {
    // carrega as programacoes filtrando a equipe medica e centro cirurgico
    const equipeMedica = this.state.equipeMedica;
    const centroCirurgico = this.state.centroCirurgico;

    let url = `api/programacoes/${equipeMedica}/${centroCirurgico}`;
    let programacoes = [];

    await dominioDemandaCirurgica.get(url).then(response => {
      programacoes = response.data.map(programacao => {
        return {
          id: programacao.id,
          diaSemana: programacao.diaSemana,
          horaInicio: programacao.horaInicio,
          horaFim: programacao.horaFim,
          salaCirurgia_id: programacao.salaCirurgia_id,
          nomeSala: programacao.descricao
        };
      });

      let listaSalas = [];

      programacoes.forEach((item) => {
        if (!this.state.salasCirurgicas[item.salaCirurgia_id]) {
          let salaJson = {
            ...this.state.salasCirurgicas,
            [item.salaCirurgia_id]: item.nomeSala
          };

          listaSalas = [
            ...listaSalas,
            {
              salaCirurgia_id: item.salaCirurgia_id,
              nomeSala: item.nomeSala
            },
          ];

          this.setState({ salasCirurgicas: salaJson });
        }
      });

      listaSalas.sort((a, b) => a.nomeSala.localeCompare(b.nomeSala));

      this.setState({
        programacoes: programacoes,
        listaSalas: listaSalas,
      }, () => {
        if (this.state.programacoes.length === 0 && (this.state.carater.id === this.state.caraterEletivo) &&
        !(JSON.parse(localStorage.getItem('equipeRequisitante')).idLegado === 9973 &&
        JSON.parse(localStorage.getItem('centroCirurgico')).idLegado === 556))
          this.showWarn('Programações de salas não encontradas neste centro cirúrgico ou equipe incorreta.', 'warn');
      });
    });
  }

  async criaEventos(info) {
    // cria os eventos dos pedidos agendados da equipe médica
    const dataInicial = moment(info.start).format('YYYY-MM-DDTHH:mm');
    const dataFinal = moment(info.end).format('YYYY-MM-DDTHH:mm');
    const equipeMedica = this.state.equipeMedica;

    let url = `api/pedidosWizard/${dataInicial}/${dataFinal}/${equipeMedica}/${this.state.salaCirurgicaSelecionada}`;
    let novosEventos = [];

    await dominioDemandaCirurgica.get(url).then(response => {
      novosEventos = response.data.map((evento) => {
        return {
            id: evento.id,
            title: `Pedido ${evento.codigo}`,
            start: evento.dataInicio,
            end: evento.dataFim,
        };
      });

      if (localStorage.getItem('idPedidoConferencia'))
        novosEventos = novosEventos.filter(item => item.id != localStorage.getItem('idPedidoConferencia'));

      this.setState({
        eventos: this.state.eventos.concat(novosEventos)
      }, () => {
        // cria os eventos para agendar
        const diaSemanaFormatado = [7, 1, 2, 3, 4, 5, 6];
        const intervaloAgendamento = 30;
        const programacoesSelecionadas = this.state.programacoes.filter(item => item.salaCirurgia_id == this.state.salaCirurgicaSelecionada);
        let eventosAgendar = [];

        diaSemanaFormatado.forEach((item, index) => {
          let dia = moment(info.start).add(index, 'day').format('YYYY-MM-DDTHH:mm');
          let diaSemana = diaSemanaFormatado[moment(dia).day()];
          let programacoesDia = [];

          programacoesSelecionadas.forEach(programacao => {
            if (programacao.diaSemana === diaSemana) {
              programacoesDia = [...programacoesDia, programacao];
            }
          });

          programacoesDia.forEach((programacaoDia) => {
            let horarioInicialProgramacao = moment(programacaoDia.horaInicio, 'HH:mm');
            let horarioFinalProgramacao = moment(programacaoDia.horaFim, 'HH:mm');
            let vezesLoop = Math.floor(moment(horarioFinalProgramacao).diff(horarioInicialProgramacao, 'minutes') / intervaloAgendamento);
            let minutos = 0;

            for (let i = 0; i < vezesLoop; i++) {
              let horarioInicioEvento = moment(dia).add(horarioInicialProgramacao.hours(), 'hours').add(horarioInicialProgramacao.minutes() + minutos, 'minutes').format('YYYY-MM-DDTHH:mm');
              let horarioFinalDia = moment(dia).add(horarioFinalProgramacao.hours(), 'hours').add(horarioFinalProgramacao.minutes(), 'minutes').format('YYYY-MM-DDTHH:mm');
              let fimEvento = moment(horarioInicioEvento).add(this.state.duracaoTotal, 'minutes');
              let podeAgendar = true;
              
              // nao cria o evento 'agendar' quando o horario de termino da cirurgia exceder o horario final da programacao
              if (Date.parse(moment(horarioInicioEvento).add(this.state.duracaoTotal, 'minutes')) > Date.parse(moment(horarioFinalDia)))
                podeAgendar = false;

              let pedidos = this.state.eventos;
              pedidos = pedidos.filter(item => item.id !== ('agendar' || 'agendado'));

              pedidos.forEach((pedido) => {
                let inicioPedido = moment(pedido.start);
                let fimPedido = moment(pedido.end);

                if ( (moment(horarioInicioEvento).isAfter(moment(inicioPedido)) && moment(horarioInicioEvento).isBefore(moment(fimPedido))) ||
                     (moment(fimEvento).isAfter(moment(inicioPedido)) && moment(fimEvento).isBefore(moment(fimPedido)))                     ||
                     moment(horarioInicioEvento).isSameOrBefore(moment(inicioPedido)) && moment(fimEvento).isSameOrAfter(moment(pedido.end))
                ) {
                  podeAgendar = false;
                }
              });

              if (Date.parse(horarioInicioEvento) < Date.now()) podeAgendar = false;

              if (podeAgendar) {
                let evento = {
                  id: 'agendar',
                  title: `Agendar Início ${moment(horarioInicioEvento).format('HH:mm')}`,
                  start: horarioInicioEvento,
                  end: moment(horarioInicioEvento).add(intervaloAgendamento, 'minutes').format('YYYY-MM-DDTHH:mm'),
                  classNames: ['botao-agendar', `sala-${programacaoDia.salaCirurgia_id}`],
                };
  
                eventosAgendar = eventosAgendar.concat([evento]);
              }

              minutos = minutos + intervaloAgendamento;
            }
          });
        });

        // comportamento deve ser diferente quando o evento de agendamento já estiver criado
        if (this.state.eventoAgendamentoClickado) {
          this.setState({
            eventosAgendamento: this.state.eventosAgendamento.concat(eventosAgendar)
          });
        } else {
          this.setState({ 
            eventosAgendamento: this.state.eventosAgendamento.concat(eventosAgendar),
            eventos: this.state.eventos.concat(eventosAgendar)
          });
        }
      });
    });
  }

  dataSugeridaPreenchida(dataSugerida) {
    this.criaEventoAgendamento();

    // this.handleValidarDataSugerida(dataSugerida, 'dataStorage');
  }

  criaEventoAgendamento(info = null) {
    // cria evento de agendamento realizado apos clicar no evento 'agendar'
    if (!this.calendarRef.current) return;

    const horaInicio = this.state.dataSugerida;
    const horaFim = moment(horaInicio).add(this.state.duracaoTotal, 'minutes');

    if (info !== null) {
      // agendamento pelo click
      this.calendarRef.current.getApi().addEvent({
        id: 'agendado',
        title: 'Agendamento',
        start: info.event.start,
        end: moment(info.event.start).add(this.state.duracaoTotal, 'minutes').format('YYYY-MM-DDTHH:mm'),
        classNames: 'evento-agendado'
      });

      let idSala = info.event.classNames[1].replace('sala-', '');
      let salaCirurgica = {id: idSala, descricao: `Sala ${idSala}`};

      localStorage.setItem('salaCirurgia', JSON.stringify(salaCirurgica));
    } else {
      // agendamento pelo localStorage
      this.calendarRef.current.getApi().addEvent({
        id: 'agendado',
        title: 'Agendamento',
        start: Date.parse(horaInicio),
        end: Date.parse(horaFim),
        classNames: 'evento-agendado'
      });
    }

    // apos o evento de agendamento ser criado, os eventos de 'agendar' sao escondidos
    const eventosAtualizados = this.state.eventos.filter(item => item.id !== ('agendar' || 'agendado'));
    const eventosAgendamento = this.state.eventos.filter(item => item.id === 'agendar');

    this.setState({
      eventos: eventosAtualizados,
      eventosAgendamento: eventosAgendamento,
      eventoAgendamentoClickado: true
    });
  }

  removerAgendamento() {
    const elementoTimeGridWeek = document.querySelector('.data-cirurgia-pedido .fc-timeGridWeek-view');

    if (elementoTimeGridWeek && this.state.salaCirurgicaSelecionada === 0)
      elementoTimeGridWeek.classList.add('sem-sala');

    if (this.calendarRef.current.getApi().getEventById('agendado')) {
      this.calendarRef.current.getApi().getEventById('agendado').remove();

      localStorage.removeItem('dataSugerida');

      if (this.state.carater.id === this.state.caraterEletivo)  localStorage.removeItem('salaCirurgia');

      this.showWarn('Seleção de agendamento removida.', 'info');

      document.getElementById('dataSugerida').value = '';

      this.setState({
        eventos: this.state.eventos.concat(this.state.eventosAgendamento),
        impedirEventoAgendamento: null,
        eventoAgendamentoClickado: false,
        dataSugerida: null
      });
    }
  }

  handleEventClick(info) {
    if (info.event.id === 'agendar') {
      const dataSugerida = moment(info.event.start).format('YYYY-MM-DDTHH:mm');

      localStorage.setItem('dataSugerida', dataSugerida);
      localStorage.setItem('dataInternacao', moment(dataSugerida).format('YYYY-MM-DD'));

      this.setState({ dataInternacao: moment(dataSugerida).format('YYYY-MM-DD') });

      this.criaEventoAgendamento(info);

      this.handleValidarDataSugerida(dataSugerida, info.event.id);
    } else if (info.event.id === 'agendado') {
      localStorage.removeItem('dataSugerida');

      this.setState({ dataSugerida: '' });

      info.event.remove();

      if (this.state.carater.id === this.state.caraterEletivo)  localStorage.removeItem('salaCirurgia');

      this.setState({
        eventos: this.state.eventos.concat(this.state.eventosAgendamento),
        eventoAgendamentoClickado: false
      });
    }
  }

  handleDatesSet(info) {
    // valida se a semana ja foi carregada e chama a funcao de criar os eventos
    if (this.state.salaCirurgicaSelecionada > 0) {
      const semana = info.start.toString();

      if (this.state.semanasCarregadas.includes(semana))
        return;

      this.setState({semanasCarregadas: [...this.state.semanasCarregadas, semana]});

      this.criaEventos(info);
    }
  }

  handleValidarDataSugerida = async (value, EventoAgendamento = null) => {
    if (localStorage.getItem('reagendamento')) {
      this.setState({ dataSugerida: moment(value).format('YYYY-MM-DDTHH:mm') });
      localStorage.setItem('dataSugerida', moment(value).format('YYYY-MM-DDTHH:mm'));

      return;
    }

    const dataSugeridaFormatadaWithSlice = value.slice(0, 10);

    const dataHoje = new Date();
    dataHoje.setHours(dataHoje.getHours() - 3);
    const dataFormatada = dataHoje.toISOString().substr(0, 16);
    const dataFormatadaHoje = dataFormatada.slice(0, 10);

    const perspectivaValidacaoDosDiasModelo = JSON.parse(
      localStorage.getItem('perspectivaValidacaoDosDiasModelo')
    );
    const slaModelo = JSON.parse(localStorage.getItem('slaModelo'));

    if (
      (perspectivaValidacaoDosDiasModelo && slaModelo) ||
      (perspectivaValidacaoDosDiasModelo && slaModelo === 0)
    ) {
      const dataSugerida = new Date(value);
      const dataAtual = new Date();

      if (
        perspectivaValidacaoDosDiasModelo === this.state.perspectivaValidacaoDasHorasUteis ||
        perspectivaValidacaoDosDiasModelo === this.state.perspectivaValidacaoDasHorasCorridas
      ) {
        if (this.state.perspectivaValidacaoDasHorasCorridas === perspectivaValidacaoDosDiasModelo) {
          if (this.differenceInHoursCustom(dataSugerida, dataAtual) <= slaModelo) {
            this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');

            if (EventoAgendamento !== null)
              this.setState({ impedirEventoAgendamento: EventoAgendamento });

            document.getElementById('dataSugerida').value = '';
            return;
          }
        }

        if (this.state.perspectivaValidacaoDasHorasUteis === perspectivaValidacaoDosDiasModelo) {
          const dataSugeridaFormatada = format(dataSugerida, 'dd-MM-yyyy-HH-mm');
          const [responseDataSugerida] = await Promise.all([
            dominioOperaAspNet.get(
              `/api/validarDataCirurgiaEmHorasUteis/${dataSugeridaFormatada}/${slaModelo}`
            ),
          ]);

          if (responseDataSugerida.data.mensagem?.length > 0) {
            this.showWarn(responseDataSugerida.data.mensagem, 'warn');

            if (EventoAgendamento !== null)
              this.setState({ impedirEventoAgendamento: EventoAgendamento });

            document.getElementById('dataSugerida').value = '';
            return;
          }
        }
      }
      if (
        perspectivaValidacaoDosDiasModelo === this.state.perspectivaValidacaoDosDiasUteis ||
        perspectivaValidacaoDosDiasModelo === this.state.perspectivaValidacaoDosDiasCorridos
      ) {
        if (this.state.perspectivaValidacaoDosDiasCorridos === perspectivaValidacaoDosDiasModelo) {
          if (this.differenceInDaysCustom(dataSugerida, dataAtual) <= slaModelo) {
            this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');

            if (EventoAgendamento !== null)
              this.setState({ impedirEventoAgendamento: EventoAgendamento });

            document.getElementById('dataSugerida').value = '';
            return;
          }
        }

        if (this.state.perspectivaValidacaoDosDiasUteis === perspectivaValidacaoDosDiasModelo) {
          const dataSugeridaFormatada = format(dataSugerida, 'dd-MM-yyyy');
          const [responseDataSugerida] = await Promise.all([
            dominioOperaAspNet.get(
              `/api/validarDataCirurgiaEmDiasUteis/${dataSugeridaFormatada}/${slaModelo}`
            ),
          ]);

          if (responseDataSugerida.data.mensagem?.length > 0) {
            this.showWarn(responseDataSugerida.data.mensagem, 'warn');

            if (EventoAgendamento !== null)
              this.setState({ impedirEventoAgendamento: EventoAgendamento });

            document.getElementById('dataSugerida').value = '';
            return;
          }
        }
      }
    } else if (this.state.carater) {
      const dataSugerida = new Date(value);
      const dataAtual = new Date();
      let slaCarater = 0;
      if (this.state.carater.id === this.state.caraterUrgencia) {
        slaCarater = this.state.slaCaraterUrgencia;
        if (differenceInHours(dataSugerida, dataAtual) > slaCarater) {
          this.showWarn(
            `Você não pode fazer um pedido de urgência/emergência acima de ${slaCarater} horas.`,
            'warn'
          );

          if (this.state.dataSugerida) this.setState({ dataSugerida: null });
          if (localStorage.getItem('dataSugerida')) localStorage.removeItem('dataSugerida');

          if (EventoAgendamento !== null)
            this.setState({ impedirEventoAgendamento: EventoAgendamento });

          document.getElementById('dataSugerida').value = '';
          return;
        }
      } else if (this.state.carater.id === this.state.caraterEletivo) {
        slaCarater = this.state.slacaraterEletivo;
        const dataSugeridaOnlyDate = dataSugerida;
        dataSugeridaOnlyDate.setHours(0);
        dataSugeridaOnlyDate.setMinutes(0);
        const dataAtualOnlyDate = dataAtual;
        dataAtualOnlyDate.setHours(0);
        dataAtualOnlyDate.setMinutes(0);
        const differenceInDays = this.differenceInDaysCustom(
          dataAtualOnlyDate,
          dataSugeridaOnlyDate
        );

        if (
          this.state.carater.id === this.state.caraterEletivo &&
          dataSugeridaFormatadaWithSlice === dataFormatadaHoje
        ) {
          this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');

          if (EventoAgendamento !== null)
            this.setState({ impedirEventoAgendamento: EventoAgendamento });

          document.getElementById('dataSugerida').value = '';
          return;
        }

        if (differenceInDays <= slaCarater) {
          this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');

          if (EventoAgendamento !== null)
            this.setState({ impedirEventoAgendamento: EventoAgendamento });

          document.getElementById('dataSugerida').value = '';
          return;
        }

        if (
          this.state.perspectivaValidacaoDosDiasUteis === this.state.perspectivaValidacaoDosDias
        ) {
          const dataSugeridaFormatada = format(dataSugerida, 'dd-MM-yyyy');
          const [responseDataSugerida] = await Promise.all([
            dominioOperaAspNet.get(
              `/api/validarDataCirurgiaEmDiasUteis/${dataSugeridaFormatada}/${this.state.slacaraterEletivo}`
            ),
          ]);

          if (responseDataSugerida.data.mensagem?.length > 0) {
            this.showWarn(responseDataSugerida.data.mensagem, 'warn');

            if (EventoAgendamento !== null)
              this.setState({ impedirEventoAgendamento: EventoAgendamento });

            document.getElementById('dataSugerida').value = '';
            return;
          }
        }
      }
    }

    localStorage.setItem('dataSugerida', value);
    this.setState({ dataSugerida: value });
    setPendencia(3, PendenciasWizard.dataSugerida);

    if (
      !this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia &&
      !this.state.bloqueiaInternacao &&
      !this.state.dataInternacao &&
      this.state.modalidadeAtendimento !== this.state.modalidadeAmbulatorial
    ) {
      const dataInternacao = new Date(value);
      dataInternacao.setDate(dataInternacao.getDate() - 1);
      localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
      this.setState({ dataInternacao: this.formatDate(dataInternacao) });
    }
  };

  showWarn(msg, severity) {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 13000,
    });
  }

  formatDate = date => {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  };

  differenceInDaysCustom = (startDate, finalDate) => {
    const timeDiff = Math.abs(finalDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  };

  differenceInHoursCustom = (startDate, finalDate) => {
    const timeDiff = Math.abs(finalDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600));
    return diffDays;
  };

  handleValidaDataSugeridaJaInformadaDataInternacaoNaoInformada = () => {
    if (this.state.modalidadeAtendimento === this.state.modalidadeAmbulatorial) return;

    const dataSugerida = localStorage.getItem('dataSugerida');
    const dataInternacao = localStorage.getItem('dataInternacao');
    if (dataSugerida && dataInternacao !== Date(null)) {
      const dataSugerida = localStorage.getItem('dataSugerida');
      const dataInternacao = new Date(dataSugerida);
      dataInternacao.setDate(dataInternacao.getDate() - 1);
      localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
      this.setState({ dataInternacao: this.formatDate(dataInternacao) });
    }
  };

  alimentarStates = () => {
    const internacaoLocalStorage = localStorage.getItem('internacao');
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));
    const dataInternacao = localStorage.getItem('dataInternacao') ? localStorage.getItem('dataInternacao').replace(/^['"]|['"]$/g, '') : null;
    const dataSugerida = localStorage.getItem('dataSugerida');
    const motivoAntecipacaoInternacao = localStorage.getItem('motivoAntecipacaoInternacao');
    const tipoAcomodacao = localStorage.getItem('tipoAcomodacao');
    const leitoUTI = localStorage.getItem('leitoUTI');
    const carater = localStorage.getItem('carater');
    const equipeRequisitante = JSON.parse(localStorage.getItem('equipeRequisitante')).id;
    const centroCirurgico = JSON.parse(localStorage.getItem('centroCirurgico')).id;
    const duracaoEstimada = localStorage.getItem('duracaoEstimada');
    const salaCirurgicaSelecionada = (localStorage.getItem('salaCirurgia') !== 'undefined') ? JSON.parse(localStorage.getItem('salaCirurgia')) : null;
    const modalidadeAtendimento = JSON.parse(localStorage.getItem('modalidadeAtendimento'))?.id;
    const modalidadeAmbulatorial = configuracoes?.modalidadeAmbulatorial;

    this.setState({
      perspectivaValidacaoDasHorasUteis: configuracoes.perspectivaValidacaoDasHorasUteis,
      perspectivaValidacaoDasHorasCorridas: configuracoes.perspectivaValidacaoDasHorasCorridas,
      perspectivaValidacaoDosDiasUteis: configuracoes.perspectivaValidacaoDosDiasUteis,
      perspectivaValidacaoDosDiasCorridos: configuracoes.perspectivaValidacaoDosDiasCorridos,
      caraterUrgencia: configuracoes.caraterUrgencia,
      caraterEletivo: configuracoes.caraterEletivo,
      equipeMedica: equipeRequisitante,
      centroCirurgico: centroCirurgico,
      duracaoEstimada: duracaoEstimada
    });

    dominioDemandaCirurgica.get(`/api/statusPedidoDetail/${configuracoes.statusInicial}`).then(response => {
      this.setState({
        perspectivaValidacaoDosDias: response.data.perspectivaValidacaoDosDias,
        slaCaraterUrgencia: response.data.prazoLimiteSLAUrgencia,
        slacaraterEletivo: response.data.prazoLimiteSLAEletivo,
      });
    });

    if (internacaoLocalStorage) {
      this.setState({ internacao: JSON.parse(internacaoLocalStorage) });
    }

    if (
      internacaoLocalStorage &&
      internacaoLocalStorage !== null &&
      internacaoLocalStorage !== 'null'
    ) {
      if (
        internacaoLocalStorage &&
        internacaoLocalStorage !== null &&
        internacaoLocalStorage !== 'null'
      ) {
        if (
          JSON.parse(internacaoLocalStorage).SEQ_INTERNACAO &&
          JSON.parse(internacaoLocalStorage).SEQ_INTERNACAO !== null &&
          JSON.parse(internacaoLocalStorage).SEQ_INTERNACAO !== 'null'
        ) {
          this.setState({ bloqueiaInternacao: JSON.parse(internacaoLocalStorage) });
          const caraterDeUrgencia = {
            id: configuracoes.caraterUrgencia,
            descricao: configuracoes.caraterUrgenciaEmergencia,
          };
          this.setState({ carater: caraterDeUrgencia });
          localStorage.setItem('carater', JSON.stringify(caraterDeUrgencia));
        }
      }
    }

    if (dataSugerida) {
      this.setState({ dataSugerida });
    }

    if (dataInternacao && !(dataInternacao === null) && !(dataInternacao === 'null')) {
      this.setState({ dataInternacao: moment(dataInternacao).format('YYYY-MM-DD') });
      localStorage.setItem('dataInternacao', dataInternacao);
    }

    if (motivoAntecipacaoInternacao) {
      this.setState({ motivoAntecipacaoInternacao: JSON.parse(motivoAntecipacaoInternacao) });
    }

    const motivoAntecipacaoPermitido = JSON.parse(
      localStorage.getItem('motivoAntecipacaoPermitido')
    );

    if (motivoAntecipacaoPermitido)
      this.setState({ listaMotivosAntecipacaoInternacao: motivoAntecipacaoPermitido });
    else
      dominioDemandaCirurgica.get('/api/motivoAntecipacaoInternacao').then(response => {
        this.setState({ listaMotivosAntecipacaoInternacao: response.data });
      });

    const tipoAcomodacaoPermitido = JSON.parse(localStorage.getItem('tipoAcomodacaoPermitido'));

    if (tipoAcomodacaoPermitido) this.setState({ listaTipoAcomodacao: tipoAcomodacaoPermitido });
    else
      dominioDemandaCirurgica.get('/api/tipoAcomodacao').then(response => {
        this.setState({ listaTipoAcomodacao: response.data });
      });

    if (tipoAcomodacao && tipoAcomodacao !== null && tipoAcomodacao !== 'null') {
      this.setState({ tipoAcomodacao: JSON.parse(tipoAcomodacao) });
      setPendencia(3, PendenciasWizard.tipoAcomodacao);
    }

    if (leitoUTI) this.setState({ leitoUTI: leitoUTI === 'true' });

    if (carater) {
      this.setState({ carater: JSON.parse(carater) });
    }

    this.setState({ duracaoTotal: parseFloat(duracaoEstimada ?? 0) + parseFloat(configuracoes.intervaloUsoSalaCirurgica ?? 0) });

    if (salaCirurgicaSelecionada) {
      this.setState({ salaCirurgicaSelecionada: salaCirurgicaSelecionada.id });
    }

    if (modalidadeAtendimento) this.setState({ modalidadeAtendimento });

    if (modalidadeAmbulatorial) this.setState({ modalidadeAmbulatorial });

    // this.handleValidaDataSugeridaJaInformadaDataInternacaoNaoInformada();
  };

  render() {
    if (!this.state.renderizar) return <ProgressSpinner style={{ left: '45%' }} />;

    return (
      <div className="data-cirurgia-pedido">
        {((this.state.carater.id === this.state.caraterEletivo) &&
        !(JSON.parse(localStorage.getItem('equipeRequisitante')).idLegado === 9973 &&
        JSON.parse(localStorage.getItem('centroCirurgico')).idLegado === 556)) ?
        <><FullCalendar
          ref={this.calendarRef}
          plugins={[timeGridPlugin]}
          initialView="timeGridWeek"
          events={this.state.eventos}
          customButtons={{
            removerAgendamento: {
              text: 'Limpar',
              click: () => {if (this.state.renderizar && this.calendarRef.current) this.removerAgendamento()}
            }
          }}
          locale="pt-br"
          height="auto"
          headerToolbar={{
            left: 'removerAgendamento prev,next',
            center: 'title',
            right: ''
          }}
          displayEventTime={false}
          dayHeaderFormat={{
            weekday: 'short',
            day: 'numeric',
          }}
          datesSet={info => this.handleDatesSet(info)}
          eventClick={info => this.handleEventClick(info)}
        />
        <br />
        <Grid item xs={12} sm={12}>
          <h3>Data Cirurgia</h3>
        </Grid>
        <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              type="datetime-local"
              name="dataSugerida"
              variant="outlined"
              fullWidth
              id="dataSugerida"
              disabled={true}
              label="Data Sugerida da Cirurgia"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataSugerida}
              onChange={e => {
                this.handleValidarDataSugerida(e.target.value);
              }}
            />
        </Grid></>
        
        :

        <>
          <Grid item xs={12} sm={12}>
            <h3>Data Cirurgia</h3>
          </Grid>
          <Grid item xs={12} sm={12}>
              <TextField
                autoComplete="off"
                type="datetime-local"
                name="dataSugerida"
                variant="outlined"
                fullWidth
                id="dataSugerida"
                label="Data Sugerida da Cirurgia"
                InputLabelProps={{ shrink: true }}
                value={this.state.dataSugerida}
                onChange={e => {
                  this.handleValidarDataSugerida(e.target.value);

                  if (this.state.modalidadeAtendimento !== this.state.modalidadeAmbulatorial) {
                    localStorage.setItem('dataInternacao', moment(e.target.value).format('YYYY-MM-DD'));
                    this.setState({ dataInternacao: moment(e.target.value).format('YYYY-MM-DD') });
                  }
                }}
              />
          </Grid>
        </>
        }
          
        <br/>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Internação</h3>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              type="date"
              name="dataInternacao"
              disabled={
                this.state.bloqueiaInternacao ||
                this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia ||
                this.state.modalidadeAtendimento === this.state.modalidadeAmbulatorial
              }
              variant="outlined"
              fullWidth
              id="dataInternacao"
              label="Data da Internação"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataInternacao}
              onChange={e => {
                const dataInternacao = new Date(e.target.value);
                if (
                  isBefore(dataInternacao, new Date(this.state.dataSugerida)) &&
                  this.state.motivoAntecipacaoInternacao === null
                ) {
                  this.showWarn(
                    'É necessário informar o motivo da internação ser antecipada.',
                    'info'
                  );
                  localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
                  this.setState({ dataInternacao: this.formatDate(dataInternacao) });
                } else if (isBefore(dataInternacao, new Date(this.state.dataSugerida))) {
                  this.showWarn(
                    'De acordo com a Ordem de Serviço HCFAMEMAORD202300014, as internações antecipadas serão efetuadas a partir das 14:00 horas do dia solicitado. Garanta que o paciente seja devidamente informado.',
                    'info'
                  );
                  localStorage.setItem('dataInternacao', this.formatDate(dataInternacao));
                  this.setState({ dataInternacao: this.formatDate(dataInternacao) });
                } else if (isAfter(dataInternacao, new Date(this.state.dataSugerida))) {
                  this.showWarn(
                    'A data da internação não pode ser depois que a data sugerida para cirurgia!',
                    'warn'
                  );
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="motivoAntecipacaoInternacao"
              options={this.state.listaMotivosAntecipacaoInternacao}
              getOptionLabel={option => `${option.descricao}`}
              option
              fullWidth
              disabled={
                this.state.bloqueiaInternacao ||
                this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia ||
                this.state.modalidadeAtendimento === this.state.modalidadeAmbulatorial
              }
              value={this.state.motivoAntecipacaoInternacao}
              onChange={(e, values) => {
                localStorage.setItem('motivoAntecipacaoInternacao', JSON.stringify(values));
                this.setState({ motivoAntecipacaoInternacao: values });
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Motivo de Antecipação da Internação"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="tipoAcomodacao"
              options={this.state.listaTipoAcomodacao}
              getOptionLabel={option => `${option.descricao}`}
              option
              disabled={
                this.state.bloqueiaInternacao ||
                this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia ||
                this.state.modalidadeAtendimento === this.state.modalidadeAmbulatorial
              }
              fullWidth
              value={this.state.tipoAcomodacao}
              onChange={(e, values) => {
                localStorage.setItem('tipoAcomodacao', JSON.stringify(values));
                this.setState({ tipoAcomodacao: values });
                if (!this.state.bloqueiaInternacao)
                  setPendencia(3, PendenciasWizard.tipoAcomodacao);
              }}
              renderInput={params => (
                <TextField {...params} label="Acomodação" variant="outlined" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="checkedA"
                  id="leitoUTI"
                  disabled={
                    this.state.bloqueiaInternacao ||
                    this.state.bloqueioRecursoSistemaInternacaoPedidoCirurgia ||
                    this.state.modalidadeAtendimento === this.state.modalidadeAmbulatorial
                  }
                  checked={this.state.leitoUTI}
                  color="primary"
                  onChange={e => {
                    localStorage.setItem('leitoUTI', e.target.checked);
                    this.setState({ leitoUTI: e.target.checked });
                  }}
                />
              }
              label="Leito UTI?"
            />
          </Grid>
        </Grid>

        <Toast
          className="toast-dados-solicitacao"
          ref={el => {
            this.toast = el;
          }}
          position="top-right"
        />
      </div>
    );
  }
}

export default DataCirurgia;